import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap'

import SlideHOC from '../SlideHOC'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

class FeaturedSlideScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.rootRef, 0, { autoAlpha: 1, zIndex: 10, xPercent: 0, immediateRender: false })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.bgRef, this.props.duration * 0.95,
        { xPercent: 110 }, { xPercent: 0, delay: this.props.duration * 0.05 })
      .fromTo(this.contentRef, this.props.duration * 0.5,
        { autoAlpha: 0 }, { autoAlpha: 1, delay: this.props.duration * 0.5 }, 0)

    this.inReversedAnimation = new TimelineMax({ paused: true })
      .to(this.bgRef, 0, { xPercent: 0 })
      .to(this.contentRef, 0, { autoAlpha: 1 })
      .fromTo(this.rootRef, this.props.duration, { autoAlpha: 0, immediateRender: false }, { autoAlpha: 1, zIndex: 10 })
      .fromTo(this.wrapperRef, this.props.duration * 0.9,
        { xPercent: -15, rotationY: 100 }, { xPercent: 0, rotationY: 0 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration,
        { zIndex: 1, xPercent: 0, autoAlpha: 1, immediateRender: false }, { autoAlpha: 0 })
      .fromTo(this.wrapperRef, this.props.duration,
        { rotationY: 0, xPercent: 0 }, { xPercent: -15, rotationY: 100 }, 0)

    this.outReversedAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration,
        { xPercent: 0, autoAlpha: 1, immediateRender: false }, { xPercent: 110, immediateRender: false })
  }

  render () {
    return (
      <div className='aw_featured' ref={ref => (this.rootRef = ref)}>
        <div className='aw_featured__wrapper' ref={ref => (this.wrapperRef = ref)}>
          <div
            id='aw_featured__bg'
            className='aw_featured__bg'
            style={{ backgroundImage: `url(${this.props.bg})` }}
            ref={ref => (this.bgRef = ref)}
          />

          <div className='aw_featured__content' ref={ref => (this.contentRef = ref)}>
            <div
              id='aw_featured__img'
              className='aw_featured__img'
              style={{ backgroundImage: `url(${this.props.img})` }}
            />
            <div id='aw_featured__title' className='aw_featured__title'>{ this.props.title }</div>
            <div id='aw_featured__description' className='aw_featured__description'>
              {this.props.description.map((desc, i) =>
                <div className='aw_featured__description--text' key={i}>
                  {desc}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 1
  }

  static propTypes = {
    title: PropTypes.string,
    description: PropTypes.array,
    bg: PropTypes.string,
    img: PropTypes.string,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number
  }
}

export default SlideHOC(FeaturedSlideScene)



// WEBPACK FOOTER //
// ./src/templates/app-website/components/slide/FeaturedSlideScene.js